import React from "react";
import { vat } from "../../App";

const PriceDisplayCommercialView: React.FC<PriceDisplayViewProps> = ({
  compound,
  currency,
  customizationPrice,
  previousResellerPrice,
  basePricePVPInput,
  customizationPricePVPInput,
  handleManualEdit,
  handleAutomaticEdit,
  handleBasePriceChange,
  handleCustomizationPriceChange,
  hasCustomization,
  allowEditPrices,
}: PriceDisplayViewProps) => {
  const promoPrice = compound.price.promotional_pvp_with_vat;

  return (
    <>
      {promoPrice != null && promoPrice > 0 && (
        <div className="bg-green-100 border border-green-300 rounded-lg px-3 py-2 mb-2">
          <span className="text-sm font-medium text-green-800">
            🏷️ Preço Promocional:{" "}
            <span className="font-bold">
              {promoPrice.toLocaleString("pt-PT", {
                style: "currency",
                currency: currency,
              })}
            </span>
          </span>
          <span className="text-xs text-gray-500 ml-2 line-through">
            (
            {compound.price.value.toLocaleString("pt-PT", {
              style: "currency",
              currency: currency,
            })}
            )
          </span>
        </div>
      )}
      {customizationPrice && (
        <div className="grid grid-cols-5 gap-2 font-extrabold  text-red-400 mb-10">
          <div className="row-span-2 w-max whitespace-nowrap">
            Preço Revenda:
          </div>
          <div className="col-span-4">
            {customizationPrice.toLocaleString("pt-PT", {
              style: "currency",
              currency: currency,
            })}{" "}
            <span className={"text-xs"}>(IVA não incluído)</span>
            {previousResellerPrice != null &&
              previousResellerPrice > customizationPrice && (
                <del className="ml-2 text-xs" title="Preço anterior">
                  {previousResellerPrice.toLocaleString("pt-PT", {
                    style: "currency",
                    currency: currency,
                  })}
                </del>
              )}
          </div>
          <div className="col-span-4">
            {(
              customizationPrice *
              (1 + compound.price.vat_rate)
            ).toLocaleString("pt-PT", {
              style: "currency",
              currency: currency,
            })}{" "}
            <span className={"text-xs"}>
              (IVA incluído, taxa de {compound.price.vat_rate * 100}% aplicada)
            </span>
          </div>
        </div>
      )}
      {compound.price.value && (
        <div className="text-sm font-bold text-gray-400  is-display-block w-[450px]">
          <span className="">PVP recomendado (configuração base):</span>
          <div className="flex is-inline-flex float-end">
            <input
              id="base-price-input"
              type="number"
              style={{ width: "120px" }}
              className="text-right px-2 cursor-text hover:text-gray-600 focus:text-gray-600 focus:outline-none"
              step={0.01}
              onFocus={handleManualEdit}
              onBlur={handleAutomaticEdit}
              value={basePricePVPInput}
              onChange={handleBasePriceChange}
              readOnly={!allowEditPrices}
            />
            <span style={{ marginLeft: 0 }}>&euro;</span>
          </div>
        </div>
      )}
      {hasCustomization() && (
        <div className="text-sm font-bold text-gray-400 is-display-block w-[450px]">
          <span className="">PVP com os opcionais:</span>
          <div className="flex is-inline-flex float-end">
            <input
              id="customization-price-input"
              type="number"
              style={{ width: "120px" }}
              className="text-right px-2 cursor-text hover:text-gray-600 focus:text-gray-600 focus:outline-none"
              step={0.01}
              onFocus={handleManualEdit}
              onBlur={handleAutomaticEdit}
              value={customizationPricePVPInput}
              onChange={handleCustomizationPriceChange}
              readOnly={!allowEditPrices}
            />
            <span style={{ marginLeft: 0 }}>&euro;</span>
          </div>
        </div>
      )}
    </>
  );
};

export default PriceDisplayCommercialView;
